import Vue from "vue";
import _ from "lodash";
import store from "@/store";

Vue.prototype.trans = (string, args) => {
  let value = _.get(store.getters["user/getTranslations"], string);

  if (!value) return string;

  _.eachRight(args, (paramVal, paramKey) => {
    value = _.replace(value, `:${paramKey}`, paramVal);
  });

  return value;
};
Vue.prototype.transChoice = (string, plural, args) => {
  let value = _.get(store.getters["user/getTranslations"], string);

  if (!value) return string;

  if (plural === 1) {
    value = value.split("|")[0];
  } else if (plural === 0 || plural > 1) {
    value = value.split("|")[1];
  }
  _.eachRight(args, (paramVal, paramKey) => {
    value = _.replace(value, `:${paramKey}`, paramVal);
  });
  return value;
};
